/* eslint-disable */

import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from './firebaseConfig';
import { doc, getDoc } from 'firebase/firestore';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

function RoleProtectedRoute({ children, requiredRole }) {
  const [user, loading] = useAuthState(auth);
  const [userRole, setUserRole] = useState(null);
  const [roleLoading, setRoleLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkUserRole = async () => {
      if (!user) {
        setRoleLoading(false);
        return;
      }

      try {
        const userRef = doc(db, 'user', user.uid);
        const userSnap = await getDoc(userRef);
        
        if (!userSnap.exists()) {
          setError('Kein Benutzerprofil gefunden. Kontaktieren Sie den Administrator.');
          setRoleLoading(false);
          return;
        }

        const role = userSnap.data()?.role;
        setUserRole(role);
        setRoleLoading(false);
      } catch (err) {
        setError('Fehler beim Laden der Benutzerdaten.');
        setRoleLoading(false);
      }
    };

    checkUserRole();
  }, [user]);

  if (loading || roleLoading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        gap: 2
      }}>
        <CircularProgress />
        <Typography variant="body1">Lade Benutzerdaten...</Typography>
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (error) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        gap: 2,
        p: 3
      }}>
        <Alert severity="error" sx={{ maxWidth: 500 }}>
          {error}
        </Alert>
      </Box>
    );
  }

  // Admins haben Zugriff auf alle Bereiche
  if (userRole !== requiredRole && userRole !== 'admin') {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '100vh',
        gap: 2,
        p: 3
      }}>
        <Alert severity="warning" sx={{ maxWidth: 500 }}>
          <Typography variant="h6" gutterBottom>
            Zugriff verweigert
          </Typography>
          <Typography variant="body1">
            Sie haben keine Berechtigung für diesen Bereich. 
            Erforderte Rolle: <strong>{requiredRole}</strong><br/>
            Ihre Rolle: <strong>{userRole || 'Nicht definiert'}</strong>
          </Typography>
        </Alert>
      </Box>
    );
  }

  return children;
}

export default RoleProtectedRoute;
